// About Iggy Modal Component
// Phase 9: UI Fixes
// © 2025 precatio, llc

import React from 'react';
import './AboutIggyModal.css';

const AboutIggyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="about-modal-overlay" onClick={onClose}>
      <div className="about-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="about-modal-close" onClick={onClose}>×</button>
        
        <h2 className="about-modal-title">About Iggy</h2>
        
        <div className="about-modal-body">
          {/* Who is Iggy */}
          <section className="about-section">
            <h3>Who is Iggy?</h3>
            <p>
              Iggy is your AI spiritual companion inspired by St. Ignatius of Loyola, 
              the founder of the Jesuits and creator of the Spiritual Exercises. He guides 
              you through Ignatian prayer practices—bringing 500 years of Jesuit wisdom 
              into conversation with you.
            </p>
            <p>
              Iggy was created by <strong>Chad Torgerson</strong>, a Catholic spiritual 
              director. For human spiritual direction, visit{' '}
              <a 
                href="https://directionalfaith.com/spiritual-direction/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="about-link"
              >
                DirectionalFaith.com
              </a>.
            </p>
          </section>

          {/* What Iggy Can Do */}
          <section className="about-section">
            <h3>What Iggy Can Do</h3>
            <ul className="about-list">
              <li>
                <span className="check-icon">✅</span>
                <div>
                  <strong>Guide you through prayer</strong> - Daily Examen, novenas, Gospel 
                  meditation, and traditional Catholic prayers
                </div>
              </li>
              <li>
                <span className="check-icon">✅</span>
                <div>
                  <strong>Help with discernment</strong> - Navigate decisions using Ignatian 
                  principles of consolation and desolation
                </div>
              </li>
              <li>
                <span className="check-icon">✅</span>
                <div>
                  <strong>Offer spiritual companionship</strong> - Talk through what's on your 
                  heart, questions about faith, or struggles you're facing
                </div>
              </li>
              <li>
                <span className="check-icon">✅</span>
                <div>
                  <strong>Remember your journey</strong> - Your conversations are saved so you 
                  can pick up where you left off
                </div>
              </li>
            </ul>
          </section>

          {/* What Iggy Is Not */}
          <section className="about-section">
            <h3>What Iggy Is Not</h3>
            <ul className="about-list">
              <li>
                <span className="x-icon">❌</span>
                <div>
                  <strong>Not a replacement for human spiritual direction</strong> - Iggy is a 
                  helpful companion, but he can't replace the wisdom of a{' '}
                  <a 
                    href="https://directionalfaith.com/spiritual-direction/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="about-link"
                  >
                    trained spiritual director
                  </a>{' '}
                  or confessor
                </div>
              </li>
              <li>
                <span className="x-icon">❌</span>
                <div>
                  <strong>Not a therapist</strong> - For mental health concerns, please seek 
                  professional help from a licensed therapist
                </div>
              </li>
              <li>
                <span className="x-icon">❌</span>
                <div>
                  <strong>Not infallible</strong> - Iggy is powered by AI and can make mistakes. 
                  Use discernment and consult trusted sources for important decisions
                </div>
              </li>
              <li>
                <span className="x-icon">❌</span>
                <div>
                  <strong>Not for emergencies</strong> - If you're in crisis, please contact:
                  <ul className="crisis-list">
                    <li><strong>988 Suicide & Crisis Lifeline:</strong> Call or text 988</li>
                    <li><strong>Emergency Services:</strong> Call 911</li>
                  </ul>
                </div>
              </li>
            </ul>
          </section>

          {/* Privacy */}
          <section className="about-section">
            <h3>Privacy & Your Data</h3>
            <p>
              Your conversations are private and stored securely. We never share your prayer 
              content with third parties or use it for advertising.
            </p>
          </section>
        </div>

        <div className="about-modal-footer">
          <button className="about-modal-btn" onClick={onClose}>
            Got it, thanks
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutIggyModal;
